<template>
  <!-- Table -->
  <DataView ref="dataViewRef" v-bind="tableConfigRef">
    <!-- descripcion column -->
    <template #table__descripcion__body="{ data }">
      <div class="long-text-column">
        {{ data.descripcion }}
      </div>
    </template>
    <template #list__descripcion="{ data }">
      <div class="long-text-column">
        {{ data.descripcion }}
      </div>
    </template>
  </DataView>

  <!-- Modal -->
  <WorkspacesDialogView ref="modalRef" @saved="updateTableList" />
</template>

<script setup>
import { ref } from "vue";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import { DataView, useImmer } from "@sttedra_ui/framework";

import useTableConfig from "@/pages/_root/workspaces/workspaces-table.view-config.js";
import WorkspacesDialogView from "@/pages/_root/workspaces-dialog/WorkspacesDialogView.vue";
import { workspacesDelete } from "@/api/workspaces/workspaces.api.js";

// #region Props, Emits
// #endregion

// #region Params, Ref, Reactives, Computed
const confirm = useConfirm();
const toast = useToast();
const modalRef = ref(null);
const dataViewRef = ref(null);
const tableConfig = new useTableConfig(buildModal, deleteRegister);
const { ref: tableConfigRef } = useImmer(tableConfig);
// #endregion

// #region Functions
function buildModal(event = null) {
  modalRef.value.showModal(event ? event.data : null);
}

function deleteRegister({ data }) {
  confirm.require({
    message: "¿Desea borrar el registro?",
    header: "Borrar",
    icon: "pi pi-exclamation-triangle",
    rejectClass: "p-button-secondary p-button-outlined",
    accept: async () => {
      const response = await workspacesDelete(data.guidWorkspace);

      if (response.status == 200) {
        toast.add({
          severity: "success",
          summary: "Registro borrado",
          detail: `Se ha borrado el registro correctamente`,
          life: 3000,
        });

        updateTableList();
      } else {
        toast.add({
          severity: "error",
          summary: "Error",
          detail: "Ha ocurrido un error al borrar el registro",
          life: 3000,
        });
      }
    },
  });
}

function updateTableList() {
  dataViewRef.value.debounceRefreshAndUpdate();
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
// #endregion
</script>
